import { ModelRangeSpec } from 'src/types/model-ranges';

/**
 * Export `availableFiltersKeys`.
 */

export const availableFiltersKeys = {
  butane: 'butane',
  diameter: 'diameter',
  height: 'height',
  propane: 'propane',
  tareWeight: 'tare_weight',
  waterCapacity: 'water_capacity'
} as const;

/**
 * Export `modelRangeSpecs`.
 */

export const modelRangeSpecs = {
  butane: 'butane',
  diameter: 'diameter',
  height: 'height',
  propane: 'propane',
  tareWeight: 'tareWeight',
  waterCapacity: 'waterCapacity'
} as const;

/**
 * Export `modelRangeSpecsMeasures`.
 */

export const modelRangeSpecsMeasures = {
  [modelRangeSpecs.butane]: 'kg',
  [modelRangeSpecs.diameter]: 'mm',
  [modelRangeSpecs.height]: 'mm',
  [modelRangeSpecs.propane]: 'kg',
  [modelRangeSpecs.tareWeight]: 'kg',
  [modelRangeSpecs.waterCapacity]: 'L'
};

/**
 * Export `orderedSpecs`.
 */

export const orderedSpecs: ModelRangeSpec[] = [
  modelRangeSpecs.height,
  modelRangeSpecs.diameter,
  modelRangeSpecs.tareWeight,
  modelRangeSpecs.waterCapacity,
  modelRangeSpecs.butane,
  modelRangeSpecs.propane
];

/**
 * Export `orderedFilters`.
 */

export const orderedFilters = [
  modelRangeSpecs.waterCapacity,
  modelRangeSpecs.diameter,
  modelRangeSpecs.height,
  modelRangeSpecs.tareWeight,
  modelRangeSpecs.butane,
  modelRangeSpecs.propane
];

/**
 * Export `chemicalTypes`.
 */

export const chemicalTypes = {
  acsep: 'acsep',
  airGases: 'air_gases',
  fireSuppression: 'fire_suppression'
};

/**
 * Export `refillableOptions`.
 */

export const refillableOptions = {
  nonRefillable: 'non_refillable',
  refillable: 'refillable'
};
